module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.mainClassName, 'quote']
  }, [_c('div', {
    staticClass: "quotes"
  }, [_c('div', {
    staticClass: "quotes__icon"
  }, [_c('single-quote-svg')], 1), _c('div', {
    staticClass: "quotes__icon"
  }, [_c('single-quote-svg')], 1)]), _vm._v("\n  " + _vm._s(_vm.value) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c593d01","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/node/QuoteBlock.vue
// module id = 1174
// module chunks = 1 32